import {
  KrankenkasseOption,
  LandOption
} from '@aid/products/types/interfaces/hek.interface';

export const ADMINISTRATORS_GROUP = 'ADM';

export const KRANKENKASSEN_OPTIONS: KrankenkasseOption[] = [
  { id: '67450665', name: 'AOK Baden-Württemberg' },
  { id: '87880235', name: 'AOK Bayern' },
  { id: '20012084', name: 'AOK Bremen / Bremerhaven' },
  { id: '45118687', name: 'AOK Hessen' },
  { id: '29720865', name: 'AOK Niedersachsen' },
  { id: '90235319', name: 'AOK Nordost' },
  { id: '33526082', name: 'AOK NORDWEST' },
  { id: '05174740', name: 'AOK Plus' },
  { id: '34364249', name: 'AOK Rheinland / Hamburg' },
  { id: '51605725', name: 'AOK Rheinland-Pfalz/Saarland' },
  { id: '01029141', name: 'AOK Sachsen-Anhalt' },
  { id: '82889062', name: 'Audi BKK' },
  { id: '49003443', name: 'Bahn-BKK' },
  { id: '42938966', name: 'BARMER' },
  { id: '31323584', name: 'Bertelsmann BKK' },
  { id: '97141402', name: 'BIG Gesundheit' },
  { id: '23709856', name: 'BKK 24' },
  { id: '71579930', name: 'BKK Akzo Nobel Bayern' },
  { id: '47034975', name: 'BKK B. Braun Aesculap' },
  { id: '87271125', name: 'BMW BKK' },
  { id: '51588416', name: 'BKK der G. M. PFAFF AG' },
  { id: '34401277', name: 'BKK Deutsche Bank AG' },
  { id: '31323686', name: 'BKK Diakonie' },
  { id: '42039708', name: 'BKK DIE BERGISCHE KRANKENKASSE' },
  { id: '31323799', name: 'BKK Dürkopp Adler' },
  { id: '46939789', name: 'BKK Ernst und Young' },
  { id: '30168049', name: 'BKK Euregio' },
  { id: '26515319', name: 'BKK EWE' },
  { id: '22178373', name: 'BKK exklusiv' },
  { id: '86772584', name: 'BKK Faber-Castell und Partner' },
  { id: '20156168', name: 'BKK firmus' },
  { id: '63922962', name: 'BKK Freudenberg' },
  { id: '31323802', name: 'BKK GILDEMEISTER SEIDENSTICKER' },
  { id: '60393261', name: 'BKK Groz-Beckert' },
  { id: '47034953', name: 'BKK Herkules' },
  { id: '48063096', name: 'BKK KARL MAYER' },
  { id: '75925585', name: 'BKK KBA' },
  { id: '51980490', name: 'BKK evm' },
  { id: '74157435', name: 'BKK Krones' },
  { id: '48698889', name: 'BKK Linde' },
  { id: '67572537', name: 'BKK Mahle' },
  { id: '36916935', name: 'BKK Melitta HMR' },
  { id: '44377882', name: 'Merck BKK' },
  { id: '31323700', name: 'BKK Miele' },
  { id: '65710574', name: 'BKK MTU' },
  { id: '52598579', name: 'BKK Pfalz' },
  { id: '88571250', name: 'BKK ProVita' },
  { id: '21488086', name: 'BKK Public' },
  { id: '47307817', name: 'BKK PwC' },
  { id: '48944809', name: 'BKK R und V' },
  { id: '66626976', name: 'BKK Rieker • Ricosta • Weisser' },
  { id: '21203214', name: 'BKK Salzgitter' },
  { id: '61232758', name: 'BKK SCHEUFELEN' },
  { id: '66614249', name: 'BKK Schwarzwald-Baar-Heuberg' },
  { id: '23446040', name: 'BKK Technoform' },
  { id: '29074470', name: 'BKK TUI' },
  { id: '92644250', name: 'MKK' },
  { id: '37416328', name: 'BKK VDN' },
  { id: '69785429', name: 'BKK Verbund Plus' },
  { id: '97352653', name: 'BKK Voralb Heller Leuze Traub' },
  { id: '44037562', name: 'BKK Werra-Meissner' },
  { id: '46967693', name: 'BKK Wirtschaft und Finanzen' },
  { id: '67161380', name: 'BKK Würth' },
  { id: '69753266', name: 'BKK ZF & Partner' },
  { id: '67572593', name: 'Bosch BKK' },
  { id: '68216980', name: 'Mercedes-Benz BKK' },
  { id: '48698890', name: 'DAK-Gesundheit' },
  { id: '52156763', name: 'Debeka BKK' },
  { id: '33865367', name: 'Die Continentale BKK' },
  { id: '29717581', name: 'energie-BKK' },
  { id: '99999994', name: 'freie Heilfürsorge' },
  { id: '31209131', name: 'Heimat Krankenkasse' },
  { id: '15031806', name: 'HEK - Hanseatische Krankenkasse' },
  { id: '20013461', name: 'hkk Erste Gesundheit' },
  { id: '01020803', name: 'IKK Brandenburg und Berlin' },
  { id: '01049203', name: 'IKK classic' },
  { id: '01000455', name: 'IKK gesund plus' },
  { id: '14228571', name: 'IKK - Die Innovationskasse' },
  { id: '55811201', name: 'IKK Südwest' },
  { id: '29137937', name: 'KKH' },
  { id: '98000006', name: 'Knappschaft' },
  { id: '63494759', name: 'mhplus Betriebskrankenkasse' },
  { id: '15517302', name: 'Mobil Krankenkasse' },
  { id: '35134022', name: 'Novitas BKK' },
  { id: '15872672', name: 'pronova BKK' },
  { id: '44953697', name: 'Salus BKK' },
  { id: '15517482', name: 'SECURVITA BKK' },
  { id: '87954699', name: 'Siemens-Betriebskrankenkasse SBK' },
  { id: '74773896', name: 'SKD BKK' },
  { id: '62332660', name: 'Südzucker BKK' },
  { id: '67574619', name: 'SVLSG Baden-Württemberg' },
  {
    id: '01000308',
    name: 'SVLSG Berlin, Brandenb, Meckl.-V., Sachsen-Anhalt, Sachsen'
  },
  { id: '72360029', name: 'SVLSG Franken und Oberbayern (Bayern)' },
  { id: '47068420', name: 'SVLSG Hessen, Rheinland-Pfalz und Saarland' },
  {
    id: '87119868',
    name: 'SVLSG Niederbayern/Oberpfalz und Schwaben (Bayern)'
  },
  { id: '29147110', name: 'SVLSG Niedersachsen-Bremen' },
  { id: '39873587', name: 'SVLSG Nordrhein-Westfalen' },
  { id: '13199426', name: 'SVLSG Schleswig-Holstein und Hamburg' },
  { id: '15027365', name: 'TK - Techniker Krankenkasse' },
  { id: '40180080', name: 'VIACTIV Krankenkasse' },
  { id: '66458477', name: 'vivida BKK' },
  { id: '61232769', name: 'WMF BKK' }
];

export const COUNTRY_OPTIONS: LandOption[] = [
  { id: 'AF', name: 'Afghanistan' },
  { id: 'EG', name: 'Ägypten' },
  { id: 'AX', name: 'Åland' },
  { id: 'AL', name: 'Albanien' },
  { id: 'DZ', name: 'Algerien' },
  { id: 'AS', name: 'Amerikanisch-Samoa' },
  { id: 'VI', name: 'Amerikanische Jungferninseln' },
  { id: 'AD', name: 'Andorra' },
  { id: 'AO', name: 'Angola' },
  { id: 'AI', name: 'Anguilla' },
  { id: 'AQ', name: 'Antarktis' },
  { id: 'AG', name: 'Antigua und Barbuda' },
  { id: 'GQ', name: 'Äquatorialguinea' },
  { id: 'AR', name: 'Argentinien' },
  { id: 'AM', name: 'Armenien' },
  { id: 'AW', name: 'Aruba' },
  { id: 'AZ', name: 'Aserbaidschan' },
  { id: 'ET', name: 'Äthiopien' },
  { id: 'AU', name: 'Australien' },
  { id: 'BS', name: 'Bahamas' },
  { id: 'BH', name: 'Bahrain' },
  { id: 'BD', name: 'Bangladesch' },
  { id: 'BB', name: 'Barbados' },
  { id: 'BY', name: 'Belarus (Weißrussland)' },
  { id: 'BE', name: 'Belgien' },
  { id: 'BZ', name: 'Belize' },
  { id: 'BJ', name: 'Benin' },
  { id: 'BM', name: 'Bermuda' },
  { id: 'BT', name: 'Bhutan' },
  { id: 'BO', name: 'Bolivien' },
  { id: 'BQ', name: 'Bonaire, Saba, Sint Eustatius' },
  { id: 'BA', name: 'Bosnien und Herzegowina' },
  { id: 'BW', name: 'Botsuana' },
  { id: 'BV', name: 'Bouvetinsel' },
  { id: 'BR', name: 'Brasilien' },
  { id: 'VG', name: 'Britische Jungferninseln' },
  { id: 'IO', name: 'Britisches Territorium im Indischen Ozean' },
  { id: 'BN', name: 'Brunei Darussalam' },
  { id: 'BG', name: 'Bulgarien' },
  { id: 'BF', name: 'Burkina Faso' },
  { id: 'BI', name: 'Burundi' },
  { id: 'CL', name: 'Chile' },
  { id: 'CN', name: 'China' },
  { id: 'CK', name: 'Cookinseln' },
  { id: 'CR', name: 'Costa Rica' },
  { id: 'CI', name: "Côte d'Ivoire (Elfenbeinküste)" },
  { id: 'CW', name: 'Curaçao' },
  { id: 'DK', name: 'Dänemark' },
  { id: 'DE', name: 'Deutschland' },
  { id: 'DM', name: 'Dominica' },
  { id: 'DO', name: 'Dominikanische Republik' },
  { id: 'DJ', name: 'Dschibuti' },
  { id: 'EC', name: 'Ecuador' },
  { id: 'SV', name: 'El Salvador' },
  { id: 'ER', name: 'Eritrea' },
  { id: 'EE', name: 'Estland' },
  { id: 'SZ', name: 'Eswatini (Swasiland)' },
  { id: 'FK', name: 'Falklandinseln' },
  { id: 'FO', name: 'Färöer' },
  { id: 'FJ', name: 'Fidschi' },
  { id: 'FI', name: 'Finnland' },
  { id: 'FR', name: 'Frankreich' },
  { id: 'GF', name: 'Französisch-Guayana' },
  { id: 'PF', name: 'Französisch-Polynesien' },
  { id: 'TF', name: 'Französische Süd- und Antarktisgebiete' },
  { id: 'GA', name: 'Gabun' },
  { id: 'GM', name: 'Gambia' },
  { id: 'GE', name: 'Georgien' },
  { id: 'GH', name: 'Ghana' },
  { id: 'GI', name: 'Gibraltar' },
  { id: 'GD', name: 'Grenada' },
  { id: 'GR', name: 'Griechenland' },
  { id: 'GL', name: 'Grönland' },
  { id: 'GP', name: 'Guadeloupe' },
  { id: 'GU', name: 'Guam' },
  { id: 'GT', name: 'Guatemala' },
  { id: 'GG', name: 'Guernsey' },
  { id: 'GN', name: 'Guinea' },
  { id: 'GW', name: 'Guinea-Bissau' },
  { id: 'GY', name: 'Guyana' },
  { id: 'HT', name: 'Haiti' },
  { id: 'HM', name: 'Heard und McDonaldinseln' },
  { id: 'HN', name: 'Honduras' },
  { id: 'HK', name: 'Hongkong' },
  { id: 'IN', name: 'Indien' },
  { id: 'ID', name: 'Indonesien' },
  { id: 'IM', name: 'Insel Man' },
  { id: 'IQ', name: 'Irak' },
  { id: 'IR', name: 'Iran' },
  { id: 'IE', name: 'Irland' },
  { id: 'IS', name: 'Island' },
  { id: 'IL', name: 'Israel' },
  { id: 'IT', name: 'Italien' },
  { id: 'JM', name: 'Jamaika' },
  { id: 'JP', name: 'Japan' },
  { id: 'YE', name: 'Jemen' },
  { id: 'JE', name: 'Jersey' },
  { id: 'JO', name: 'Jordanien' },
  { id: 'KY', name: 'Kaimaninseln' },
  { id: 'KH', name: 'Kambodscha' },
  { id: 'CM', name: 'Kamerun' },
  { id: 'CA', name: 'Kanada' },
  { id: 'CV', name: 'Kap Verde' },
  { id: 'KZ', name: 'Kasachstan' },
  { id: 'QA', name: 'Katar' },
  { id: 'KE', name: 'Kenia' },
  { id: 'KG', name: 'Kirgisistan' },
  { id: 'KI', name: 'Kiribati' },
  { id: 'CC', name: 'Kokosinseln' },
  { id: 'CO', name: 'Kolumbien' },
  { id: 'KM', name: 'Komoren' },
  { id: 'CD', name: 'Kongo, Demokratische Republik' },
  { id: 'CG', name: 'Kongo, Republik' },
  { id: 'KP', name: 'Korea, Nord' },
  { id: 'KR', name: 'Korea, Süd' },
  { id: 'HR', name: 'Kroatien' },
  { id: 'CU', name: 'Kuba' },
  { id: 'KW', name: 'Kuwait' },
  { id: 'LA', name: 'Laos' },
  { id: 'LS', name: 'Lesotho' },
  { id: 'LV', name: 'Lettland' },
  { id: 'LB', name: 'Libanon' },
  { id: 'LR', name: 'Liberia' },
  { id: 'LY', name: 'Libyen' },
  { id: 'LI', name: 'Liechtenstein' },
  { id: 'LT', name: 'Litauen' },
  { id: 'LU', name: 'Luxemburg' },
  { id: 'MO', name: 'Macau' },
  { id: 'MG', name: 'Madagaskar' },
  { id: 'MW', name: 'Malawi' },
  { id: 'MY', name: 'Malaysia' },
  { id: 'MV', name: 'Malediven' },
  { id: 'ML', name: 'Mali' },
  { id: 'MT', name: 'Malta' },
  { id: 'MA', name: 'Marokko' },
  { id: 'MH', name: 'Marshallinseln' },
  { id: 'MQ', name: 'Martinique' },
  { id: 'MR', name: 'Mauretanien' },
  { id: 'MU', name: 'Mauritius' },
  { id: 'YT', name: 'Mayotte' },
  { id: 'MX', name: 'Mexiko' },
  { id: 'FM', name: 'Mikronesien' },
  { id: 'MD', name: 'Moldau' },
  { id: 'MC', name: 'Monaco' },
  { id: 'MN', name: 'Mongolei' },
  { id: 'ME', name: 'Montenegro' },
  { id: 'MS', name: 'Montserrat' },
  { id: 'MZ', name: 'Mosambik' },
  { id: 'MM', name: 'Myanmar (Burma)' },
  { id: 'NA', name: 'Namibia' },
  { id: 'NR', name: 'Nauru' },
  { id: 'NP', name: 'Nepal' },
  { id: 'NC', name: 'Neukaledonien' },
  { id: 'NZ', name: 'Neuseeland' },
  { id: 'NI', name: 'Nicaragua' },
  { id: 'NL', name: 'Niederlande' },
  { id: 'NE', name: 'Niger' },
  { id: 'NG', name: 'Nigeria' },
  { id: 'NU', name: 'Niue' },
  { id: 'MP', name: 'Nördliche Marianen' },
  { id: 'MK', name: 'Nordmazedonien' },
  { id: 'NF', name: 'Norfolkinsel' },
  { id: 'NO', name: 'Norwegen' },
  { id: 'OM', name: 'Oman' },
  { id: 'AT', name: 'Österreich' },
  { id: 'PK', name: 'Pakistan' },
  { id: 'PS', name: 'Palästinensische Autonomiegebiete' },
  { id: 'PW', name: 'Palau' },
  { id: 'PA', name: 'Panama' },
  { id: 'PG', name: 'Papua-Neuguinea' },
  { id: 'PY', name: 'Paraguay' },
  { id: 'PE', name: 'Peru' },
  { id: 'PH', name: 'Philippinen' },
  { id: 'PN', name: 'Pitcairninseln' },
  { id: 'PL', name: 'Polen' },
  { id: 'PT', name: 'Portugal' },
  { id: 'PR', name: 'Puerto Rico' },
  { id: 'RE', name: 'Réunion' },
  { id: 'RW', name: 'Ruanda' },
  { id: 'RO', name: 'Rumänien' },
  { id: 'RU', name: 'Russische Föderation' },
  { id: 'SB', name: 'Salomonen' },
  { id: 'ZM', name: 'Sambia' },
  { id: 'WS', name: 'Samoa' },
  { id: 'SM', name: 'San Marino' },
  { id: 'ST', name: 'São Tomé und Príncipe' },
  { id: 'SA', name: 'Saudi-Arabien' },
  { id: 'SE', name: 'Schweden' },
  { id: 'CH', name: 'Schweiz' },
  { id: 'SN', name: 'Senegal' },
  { id: 'RS', name: 'Serbien' },
  { id: 'SC', name: 'Seychellen' },
  { id: 'SL', name: 'Sierra Leone' },
  { id: 'ZW', name: 'Simbabwe' },
  { id: 'SG', name: 'Singapur' },
  { id: 'SX', name: 'Sint Maarten' },
  { id: 'SK', name: 'Slowakei' },
  { id: 'SI', name: 'Slowenien' },
  { id: 'SO', name: 'Somalia' },
  { id: 'ES', name: 'Spanien' },
  { id: 'LK', name: 'Sri Lanka' },
  { id: 'BL', name: 'St. Barthélemy' },
  { id: 'SH', name: 'St. Helena' },
  { id: 'KN', name: 'St. Kitts und Nevis' },
  { id: 'LC', name: 'St. Lucia' },
  { id: 'MF', name: 'St. Martin (französischer Teil)' },
  { id: 'PM', name: 'St. Pierre und Miquelon' },
  { id: 'VC', name: 'St. Vincent und die Grenadinen' },
  { id: 'ZA', name: 'Südafrika' },
  { id: 'SD', name: 'Sudan' },
  { id: 'GS', name: 'Südgeorgien und die Südlichen Sandwichinseln' },
  { id: 'SS', name: 'Südsudan' },
  { id: 'SR', name: 'Suriname' },
  { id: 'SJ', name: 'Svalbard und Jan Mayen' },
  { id: 'SY', name: 'Syrien' },
  { id: 'TJ', name: 'Tadschikistan' },
  { id: 'TW', name: 'Taiwan' },
  { id: 'TZ', name: 'Tansania' },
  { id: 'TH', name: 'Thailand' },
  { id: 'TL', name: 'Timor-Leste (Osttimor)' },
  { id: 'TG', name: 'Togo' },
  { id: 'TK', name: 'Tokelau' },
  { id: 'TO', name: 'Tonga' },
  { id: 'TT', name: 'Trinidad und Tobago' },
  { id: 'TD', name: 'Tschad' },
  { id: 'CZ', name: 'Tschechische Republik' },
  { id: 'TN', name: 'Tunesien' },
  { id: 'TR', name: 'Türkei' },
  { id: 'TM', name: 'Turkmenistan' },
  { id: 'TC', name: 'Turks- und Caicosinseln' },
  { id: 'TV', name: 'Tuvalu' },
  { id: 'UG', name: 'Uganda' },
  { id: 'UA', name: 'Ukraine' },
  { id: 'HU', name: 'Ungarn' },
  { id: 'UY', name: 'Uruguay' },
  { id: 'UZ', name: 'Usbekistan' },
  { id: 'VU', name: 'Vanuatu' },
  { id: 'VA', name: 'Vatikanstadt' },
  { id: 'VE', name: 'Venezuela' },
  { id: 'AE', name: 'Vereinigte Arabische Emirate' },
  { id: 'US', name: 'Vereinigte Staaten von Amerika' },
  { id: 'GB', name: 'Vereinigtes Königreich' },
  { id: 'VN', name: 'Vietnam' },
  { id: 'WF', name: 'Wallis und Futuna' },
  { id: 'CX', name: 'Weihnachtsinsel' },
  { id: 'EH', name: 'Westsahara' },
  { id: 'CF', name: 'Zentralafrikanische Republik' },
  { id: 'CY', name: 'Zypern' }
];
